import {
  connect as adFoxConnect,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
} from '@cian/adfox-component';
import * as React from 'react';

import { useAdsDisabled } from '../../../../../browser/utils/hooks';
import { AdfoxContext } from '../../../../utils/adfox/context';
import { OwnTemplates } from './OwnTemplates';

const AdFoxBannerComponent = adFoxConnect(OwnTemplates);

type TAdFoxBannerProps = TAdFoxBannerComponentProps & {
  disableYan?: boolean;
  position?: number;
};

export function AdFoxBanner(props: TAdFoxBannerProps) {
  const [isHidden, setHidden] = React.useState(false);
  const context = React.useMemo(() => ({ position: props.position }), [props.position]);

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData) => {
      const { bundleName } = data;

      if (props.disableYan && bundleName === 'banner.direct') {
        setHidden(true);
      }
    },
    [props.disableYan],
  );

  const handleStub = React.useCallback(() => {
    setHidden(true);
    if (props.onStub) {
      props.onStub();
    }
  }, []);

  const handleError = React.useCallback(error => {
    if (props.onError) {
      props.onError(error);
    }
  }, []);

  useAdsDisabled(() => {
    handleStub();
  }, []);

  if (isHidden) {
    return null;
  }

  return (
    <AdfoxContext.Provider value={context}>
      <AdFoxBannerComponent {...props} onLoad={handleLoad} onStub={handleStub} onError={handleError} />
    </AdfoxContext.Provider>
  );
}
